export class MatchRound {
  constructor(random = Math.random) {
    this.deck = [0, 0, 0, 1, 1, 1, 2, 2, 2];
    for (let i = this.deck.length - 1; i > 0; i--) {
      const j = Math.floor(random() * (i + 1));
      [this.deck[i], this.deck[j]] = [this.deck[j], this.deck[i]];
    }
    this.turned = [];
    this.won = false;
  }
  turn(index) {
    if (!Number.isInteger(index) || index < 0 || index >= 9 || this.won || this.turned.length === 3 || this.turned.includes(index)) return 'ignored';
    this.turned.push(index);
    if (this.turned.length < 3) return 'pending';
    this.won = this.turned.every(i => this.deck[i] === this.deck[this.turned[0]]);
    return this.won ? 'win' : 'miss';
  }
  resetMiss() {
    if (!this.won) this.turned = [];
  }
}

function initGame(dialog) {
  if (dialog.dataset.gameReady) return;
  dialog.dataset.gameReady = 'true';
  const buttons = [...dialog.querySelectorAll('[data-tb-match-card]')];
  const faces = [...dialog.querySelector('[data-tb-match-faces]').content.children].map(el => el.textContent);
  const status = dialog.querySelector('[data-tb-match-status]');
  const result = dialog.querySelector('.tb-match-result');
  const clock = dialog.querySelector('[data-tb-match-time]');
  const gameStep = dialog.querySelector('[data-tb-launch-step="1"]');
  const abort = new AbortController();
  let round, started, elapsed = 0, activeSince = 0, ticker, flipTimer;
  const cardLabel = index => dialog.dataset.cardLabel.replace('[number]', String(index + 1));
  const drawTime = () => {
    const ms = elapsed + (activeSince ? performance.now() - activeSince : 0);
    const secs = Math.floor(ms / 1000);
    clock.textContent = `${String(Math.floor(secs / 60)).padStart(2, '0')}:${String(secs % 60).padStart(2, '0')}`;
  };
  const syncTimer = () => {
    const running = started && !round.won && dialog.open && !gameStep.hidden && !document.hidden;
    if (running && !activeSince) { activeSince = performance.now(); ticker = setInterval(drawTime, 250); }
    if (!running && activeSince) { elapsed += performance.now() - activeSince; activeSince = 0; clearInterval(ticker); }
    drawTime();
  };
  const renderCards = () => buttons.forEach((button, index) => {
    const turned = round.turned.includes(index);
    button.classList.toggle('is-turned', turned);
    button.setAttribute('aria-pressed', String(turned));
    button.setAttribute('aria-disabled', String(round.won || turned || round.turned.length === 3));
    button.setAttribute('aria-label', turned ? `${index + 1}: ${faces[round.deck[index]]}` : cardLabel(index));
    button.querySelector('.tb-match-card__back').textContent = turned ? faces[round.deck[index]] : '';
  });
  const reset = () => {
    clearTimeout(flipTimer); clearInterval(ticker);
    round = new MatchRound(); started = false; elapsed = 0; activeSince = 0;
    result.hidden = true;
    dialog.classList.remove('has-match');
    status.textContent = dialog.dataset.ready;
    renderCards(); drawTime();
  };
  buttons.forEach((button, index) => button.addEventListener('click', () => {
    const outcome = round.turn(index);
    if (outcome === 'ignored') return;
    started = true;
    renderCards(); syncTimer();
    if (outcome === 'pending') status.textContent = dialog.dataset.selected.replace('[count]', String(round.turned.length));
    if (outcome === 'miss') {
      status.textContent = dialog.dataset.miss;
      flipTimer = setTimeout(() => { round.resetMiss(); renderCards(); status.textContent = dialog.dataset.ready; }, 1400);
    }
    if (outcome === 'win') {
      status.textContent = dialog.dataset.win;
      result.hidden = false;
      dialog.classList.add('has-match');
    }
  }, { signal: abort.signal }));
  dialog.querySelector('[data-tb-match-replay]').addEventListener('click', () => { reset(); buttons[0].focus(); }, { signal: abort.signal });
  document.addEventListener('visibilitychange', syncTimer, { signal: abort.signal });
  const observer = new MutationObserver(syncTimer);
  observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
  observer.observe(gameStep, { attributes: true, attributeFilter: ['hidden'] });
  const unload = event => {
    if (!event.target.contains(dialog)) return;
    clearInterval(ticker); clearTimeout(flipTimer); observer.disconnect(); abort.abort();
    document.removeEventListener('shopify:section:unload', unload);
  };
  document.addEventListener('shopify:section:unload', unload);
  reset();
}
if (typeof document !== 'undefined') {
  const init = () => document.querySelectorAll('[data-tb-match]').forEach(initGame);
  init();
  document.addEventListener('shopify:section:load', init);
}
